var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72167",
    "data-name": "Path 72167",
    d: "M6.235,6.453A8,8,0,0,0,15.052,19.4a3.454,3.454,0,0,0-.241-1.723,12.3,12.3,0,0,0-2.253-2.844c-.338-.355-.316-.627-.2-1.436l.014-.091c.082-.554.22-.882,2.085-1.178A1.281,1.281,0,0,1,16,12.878c.038.058.076.115.116.172a1.839,1.839,0,0,0,.938.757c.164.075.37.169.645.325.652.373.652.793.652,1.716v.1a5.225,5.225,0,0,1-.1,1.034,8,8,0,0,0-3.1-12.341A7.885,7.885,0,0,0,13.575,5.91c-.135.185-.327,1.132-.949,1.21a3.63,3.63,0,0,1-.614-.009c-.622-.04-1.472-.095-1.744.644a2.927,2.927,0,0,0,.356,2.4.586.586,0,0,1,.046.519,1.019,1.019,0,0,1-.292.5,2.764,2.764,0,0,1-.419-.43,2.753,2.753,0,0,0-1.211-.959c-.184-.051-.386-.093-.582-.134C7.616,9.532,6.994,9.4,6.85,9.093a2.166,2.166,0,0,1-.1-.865,3.188,3.188,0,0,0-.2-1.345A1.276,1.276,0,0,0,6.235,6.453ZM12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22Z",
    transform: "translate(-2 -2)",
    fill: "#c38f51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIcon);
export default __webpack_public_path__ + "static/media/country_icon.96ee736d357bb453dad766c22663a025.svg";
export { ForwardRef as ReactComponent };